import React, { useMemo } from 'react';
import AntIcon from '@ant-design/icons';
import { icons } from 'src/components/general/icon/icons';

export type IconProps = {
  type: string;
  className?: string;
  style?: {};
  viewBox?: string;
  title?: string;
  onClick?: (e?: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
  lggTestId?: string;
};

export const Icon = React.forwardRef<HTMLSpanElement, IconProps>(
  ({ type, title, style, onClick, className, lggTestId, ...rest }, ref) => {
    const IconComponent: any = icons[type] || type;

    // Keep the component identity stable across renders: an inline function would
    // remount the <svg> on every re-render, and if that happens between mousedown and
    // mouseup (e.g. a blur-triggered state update) the browser drops the click.
    const SvgComponent = useMemo(
      () => () =>
        <IconComponent preserveAspectRatio="xMidYMin meet" fill="currentColor" />,
      [IconComponent],
    );

    return (
      <AntIcon
        ref={ref}
        title={title}
        data-icon={type}
        style={style}
        onClick={onClick}
        className={`lgg-icon ${className || ''}`}
        data-lgg-id={lggTestId}
        {...rest}
        component={SvgComponent}
      />
    );
  },
);
